// extracted by mini-css-extract-plugin
export default {"project":"project_project__uLD6G","projectContent":"project_projectContent__iRW5M"};